import React from 'react';
import { createCommand, Option } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const publishCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const t = createI18nT();

  return createCommand('publish')
    .description(t('site_publish_command_def.description'))
    .addOption(
      new Option(
        '-y, --approve-preview',
        t('site_publish_command_def.option.approve_preview')
      ).conflicts('force')
    )
    .option('-f, --force', t('site_publish_command_def.option.force'))
    .action(async (options, command) => {
      const { approvePreview = false, force = false } = options;

      const { renderCommand } = await import('./render-command.js');
      const { PublishCommand } = await import(
        '../components/PublishCommand/PublishCommand.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <PublishCommand approvePreview={approvePreview} force={force} />
      );
    });
};
